import styles from "./dropdown.module.scss";
import { Link } from "react-router-dom";
import { useState } from "react";

//on click toggle class

function DropDown() {
  const [dropdownstate, setdropdown] = useState(styles.dropdownmenuhide);

  var toggledropdown = () => {
    if (dropdownstate === styles.dropdownmenuhide) {
      setdropdown(styles.dropdownmenushow);
    } else if (dropdownstate === styles.dropdownmenushow) {
      setdropdown(styles.dropdownmenuhide);
    }
  };

  var Separator = () => <div className={styles.separator} />;

  return (
    <div>
      <div
        onClick={() => toggledropdown()}
        className={styles.link}
        onMouseEnter={() => toggledropdown()}
      >
        Edit
      </div>
      <div className={dropdownstate} onMouseLeave={() => toggledropdown()}>
        <div className={styles.dropdownitems}>
          <Link to="edithome" className={styles.link}>
            Edit Home
          </Link>
          <Separator />
          <Link to="editportfolio" className={styles.link}>
            Edit Portfolio
          </Link>
          <Separator />
          <Link to="editresume" className={styles.link}>
            Edit Resume
          </Link>
          <Separator />
          <Link to="editcontact" className={styles.link}>
            Edit Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

export default DropDown;
